import { useSteps } from '@perpay-web/hooks/useSteps';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

const ADDRESS_COLLECTION_STEP = 'address-collection';
const SUCCESS_STEP = 'success';

const CARD_MIGRATION_MODAL_STEPS = [ADDRESS_COLLECTION_STEP, SUCCESS_STEP];

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const hook = useSteps(
            CARD_MIGRATION_MODAL_STEPS,
            ADDRESS_COLLECTION_STEP,
        );

        return <Context.Provider value={hook}>{children}</Context.Provider>;
    };

    return Provider;
};

export const [CardMigrationProvider] = createContextProvider(providerFactory);
